import { FunctionComponent, useState } from "react";
import ProgressBarItem from "./ProgressBarItem";

type ProgressBarPage = {
  id: string;
  title: string;
};

type ProgressBarProps = {
  pages: Array<ProgressBarPage>;
  active: string;
  activeIndex: number;
  setActivePage: Function;
};

const ProgressBar: FunctionComponent<ProgressBarProps> = ({
  pages,
  active,
  activeIndex,
  setActivePage,
}) => {
  let currentItem;
  const items = pages.map((page, index) => {
    const item = (
      <ProgressBarItem
        title={page.title}
        key={page.id}
        id={page.id}
        active={active}
        index={index}
        setActivePage={index > activeIndex ? () => null : setActivePage}
      />
    );

    return item;
  });
  return (
    <div>
      <div className=" border-gray-400 border-b my-8 lg:my-16 flex">
        {items}
      </div>
    </div>
  );
};

export default ProgressBar;
